jQuery(document).ready(function ($) {
    const reviews_carousel = new Swiper('.reviews-carousel', {
        autoHeight: true,

        grabCursor: true,

        // Mobile first
        // 1 review in view at all times
        slidesPerView: 1,
        // Swipe in groups of 1
        slidesPerGroup: 1,
        // width: 1040,
        
        slideClass: 'reviews__item',

        breakpoints: {
            // Min width - desktop
            1024: {
                // 2 reviews in view at all times
                slidesPerView: 2,

                // Swipe in groups of 2
                slidesPerGroup: 2,

                // Gap between slides — Swiper accounts for this in width calculations
                spaceBetween: 96,
            },
        }
    });
});